import classNames from "classnames";
import type { DOMNode, Element, HTMLReactParserOptions } from "html-react-parser";
import parse, { domToReact } from "html-react-parser";
import React from "react";

import Image from "@atoms/Image";

const safelist = [
  "place-self-center",
  "my-7.5",
  "items-center",
  "gap-15",
  "list-circled-number",
  "pb-2.5",
  "pb-5",
  "indent-6",
];

export function TextContent({ html }: { html: string }) {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      const domParse = domNode as Element;

      if (domParse?.name === "a") {
        // const linkText = domToReact(domParse.children as DOMNode[], options) as JSX.Element;
        // return <Link {...attributesToProps(domParse.attribs)}>{linkText}</Link>;
        return <></>;
      }

      if (domParse?.name === "p") {
        const paragraphText = domToReact(domParse.children as DOMNode[], options) as JSX.Element;
        return <p>{paragraphText}</p>;
      }

      // img와 picture 태그는 텍스트 영역에서 렌더링하지 않음 (제거)
      if (domParse?.name === "img" || domParse?.name === "picture") {
        return <></>;
      }
    },
  };

  return (
    <>
      {parse(html, options)}
      <div className={classNames("hidden!", safelist)} />
    </>
  );
}

export function ImageContent({ html }: { html: string }) {
  const extractedImages: React.ReactNode[] = [];

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      const domParse = domNode as Element;

      // img 태그를 만나면 Image 컴포넌트로 변환하여 배열에 수집
      if (domParse?.name === "img") {
        extractedImages.push(
          <Image
            alt={domParse.attribs.alt || ""}
            className="w-full"
            height={Number(domParse.attribs.height) || 1800}
            key={domParse.attribs.src || Math.random()}
            src={domParse.attribs.src}
            width={Number(domParse.attribs.width) || 1440}
          />,
        );

        return <></>;
      }
    },
  };

  parse(html, options);

  return <>{extractedImages}</>;
}
